export default {
  eula: 'Contrato de licencia de usuario final',
  serviceTerms: 'Condiciones de servicio',
};
